export default __webpack_public_path__ + "media/verification/title_locale_pt-bd59f911.png";